import Tracker from './Tracker';

const salesBoardTracker = new Tracker('salesBoard', {
	OPENED: 'opened',
	CLICKED_CARD: 'clickedCard',
	DROPPED_CARD: 'droppedCard'
});

export default salesBoardTracker;
